import React, { Fragment } from 'react';
import { useTable, useSortBy } from 'react-table';
import { Icon } from '@pwc/pwc-deals-ui';
import './list-table.scss';

const ContentTable = ({
  data,
  columns,
  initialSortColumn,
  initialSortDirection = 'desc',
  type,
  rowClassFunction,
  renderSubRowComponent,
}) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
        disableMultiSort: true,
        disableSortRemove: true,
        initialState: {
          sortBy: [
            { id: initialSortColumn, desc: initialSortDirection === 'desc' },
          ],
        },
      },
      useSortBy
    );

  const columnSortIconClassname = (column) => {
    if (!column.isSorted) {
      return '';
    }
    return `icon-table-sort-desc ${column.isSortedDesc ? 'desc' : 'asc'}`;
  };

  return (
    <div
      className="list-table content-container"
      data-testid="list-table"
      {...getTableProps()}
    >
      {headerGroups.map((headerGroup) => (
        <div className="header-row" {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map((column) => (
            <div
              {...column.getHeaderProps(column.getSortByToggleProps())}
              className="header-cell"
              data-testid={`sort-column-${column.id}`}
            >
              {column.render('Header')}
              <span className={columnSortIconClassname(column)}>
                <Icon name="desc" width="10" className="fill icon-orange" />
              </span>
            </div>
          ))}
        </div>
      ))}
      <div className="rowgroup" {...getTableBodyProps()}>
        {rows.map((row, rowIndex) => {
          prepareRow(row);
          const { original: rowData } = row;
          return (
            <Fragment key={row.index}>
              <div
                className={`list-table-row content-list-table-row ${
                  rowClassFunction && rowClassFunction(rowData)
                }`.trim()}
                data-testid={`${type}-row-${rowIndex}`}
                {...row.getRowProps()}
              >
                <div className="list-table-subrow">
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <div
                        className="cell"
                        data-testid={`${type}-row-${rowIndex}-cell-${cellIndex}`}
                        {...cell.getCellProps({
                          className: cell.column.className,
                        })}
                      >
                        {cell.render('Cell')}
                      </div>
                    );
                  })}
                </div>
                {renderSubRowComponent && (
                  <div className="list-table-subrow list-table-row-sub-component">
                    {renderSubRowComponent(rowData)}
                  </div>
                )}
              </div>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ContentTable;
